/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Save } from 'lucide-react';
import { adminApi } from '../../lib/api';

const WhatsAppTab = () => {
  const [cfg, setCfg] = useState({ phone: '', message: '', is_active: true });
  const [initial, setInitial] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const data = await adminApi.getWhatsApp();
        const normalized = {
          phone: data.phone || '',
          message: data.message || '',
          is_active: !!data.is_active,
        };
        setCfg(normalized);
        setInitial(normalized);
      } catch (e) {
        setErr('Failed to load WhatsApp settings');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const dirty = JSON.stringify(cfg) !== JSON.stringify(initial);

  const save = async () => {
    setSaving(true);
    setErr('');
    setMsg('');
    try {
      const res = await adminApi.setWhatsApp(cfg);
      setCfg(res);
      setInitial(res);
      setMsg('WhatsApp settings updated.');
      setTimeout(() => setMsg(''), 3000);
    } catch (e) {
      setErr(e?.response?.data?.detail || 'Failed to save');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="mt-8 text-[#7a6a5a]">Loading…</div>;

  return (
    <div className="mt-8 max-w-2xl" data-testid="whatsapp-tab">
      <div className="flex items-start justify-between flex-wrap gap-4 mb-6">
        <div>
          <div className="text-[11px] tracking-[0.28em] text-[#3a2e26]">FLOATING WHATSAPP BUTTON</div>
          <p className="mt-2 text-sm text-[#5a4a3e] max-w-xl">
            Configure the bottom-right WhatsApp button shown on every page. Leave the phone empty or turn off to hide the button.
          </p>
        </div>
        <button
          onClick={save}
          disabled={!dirty || saving}
          data-testid="whatsapp-save-btn"
          className="inline-flex items-center gap-2 bg-[#1a1410] text-[#f5f1e6] px-6 py-3 text-[11px] tracking-[0.32em] disabled:opacity-40"
        >
          <Save className="w-4 h-4" strokeWidth={1.6} />
          {saving ? 'SAVING…' : 'SAVE CHANGES'}
        </button>
      </div>

      {err && <div className="mb-4 p-3 bg-[#f3e3d8] border border-[#cdc2b1] text-sm text-[#7a3a2a]">{err}</div>}
      {msg && <div className="mb-4 p-3 bg-[#e6efe1] border border-[#b7ceac] text-sm text-[#3d5a2a]">{msg}</div>}

      <div className="border border-[#e5dfd0] p-6 bg-white/50 space-y-5">
        <label className="flex items-center gap-3 text-sm">
          <input
            type="checkbox"
            checked={cfg.is_active}
            onChange={(e) => setCfg({ ...cfg, is_active: e.target.checked })}
            data-testid="whatsapp-active-toggle"
            className="w-4 h-4 accent-[#1a1410]"
          />
          Show WhatsApp button on the site
        </label>

        <div>
          <label className="text-[10px] tracking-[0.22em] text-[#7a6a5a]">WHATSAPP NUMBER (country code + digits, e.g. 919812345678)</label>
          <input
            value={cfg.phone}
            onChange={(e) => setCfg({ ...cfg, phone: e.target.value.replace(/[^0-9]/g, '').slice(0, 15) })}
            placeholder="917875779190"
            data-testid="whatsapp-phone-input"
            className="mt-2 w-full bg-transparent border border-[#cdc2b1] focus:border-[#1a1410] p-3 text-sm font-mono focus:outline-none"
          />
        </div>

        <div>
          <label className="text-[10px] tracking-[0.22em] text-[#7a6a5a]">PREFILLED MESSAGE (optional)</label>
          <textarea
            value={cfg.message}
            onChange={(e) => setCfg({ ...cfg, message: e.target.value.slice(0, 500) })}
            rows={3}
            maxLength={500}
            placeholder="Hi Velouva! I'm interested in your products and would like some assistance."
            data-testid="whatsapp-message-input"
            className="mt-2 w-full bg-transparent border border-[#cdc2b1] focus:border-[#1a1410] p-3 text-sm focus:outline-none"
          />
          <p className="text-[10px] text-[#7a6a5a] mt-1">{cfg.message.length}/500 characters</p>
        </div>

        {cfg.is_active && cfg.phone && (
          <div className="pt-4 border-t border-[#e5dfd0]">
            <div className="text-[10px] tracking-[0.22em] text-[#7a6a5a] mb-2">PREVIEW LINK</div>
            <a
              href={`https://wa.me/${cfg.phone}${cfg.message ? `?text=${encodeURIComponent(cfg.message)}` : ''}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs font-mono text-[#3d5a2a] break-all underline"
            >
              https://wa.me/{cfg.phone}{cfg.message ? `?text=${encodeURIComponent(cfg.message)}` : ''}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default WhatsAppTab;
